import { useAuthStore } from '@/stores/authStore'
import { api } from './config'

export const createOrganization = async (data: any, token: string) => {
  const response = await api
    .post<any>('/organizations/onboarding', data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response: any) => response.data.data)

  return response
}

export const getOrganization = async (organizationId: string) => {
  const accessToken = useAuthStore.getState().auth.accessToken

  return api
    .get(`organizations/${organizationId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response: any) => response.data.data)
}

export const getUserOrganization = async () => {
  const accessToken = useAuthStore.getState().auth.accessToken

  return api
    .get(`organizations/user`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response: any) => response.data.data)
}

export const updateOrganization = async (organizationId: string, data: any) => {
  const accessToken = useAuthStore.getState().auth.accessToken

  return api
    .put(`organizations/${organizationId}`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response: any) => response.data.data)
}
